/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Notesplaceholder2Inputs */

const en_coinvestments_notesplaceholder2 = /** @type {(inputs: Coinvestments_Notesplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons for selecting this organisation`)
};

/**
* | output |
* | --- |
* | "Reasons for selecting this organisation" |
*
* @param {Coinvestments_Notesplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_notesplaceholder2 = /** @type {((inputs?: Coinvestments_Notesplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Notesplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_notesplaceholder2(inputs)
});
export { coinvestments_notesplaceholder2 as "coInvestments_notesPlaceholder" }